// google analytics with cookie constent banner

// get the text and link content for the consent banner form data-attributes in the footer tag
var consentMessage = document.getElementsByTagName('footer')[0].getAttribute('data-consent-message');
var consentDismiss = document.getElementsByTagName('footer')[0].getAttribute('data-consent-dismiss');
var consentDeny = document.getElementsByTagName('footer')[0].getAttribute('data-consent-deny');
var consentLink = document.getElementsByTagName('footer')[0].getAttribute('data-consent-link');
var consentHref = document.getElementsByTagName('footer')[0].getAttribute('data-consent-href');
// ------------------------------------------------------------------------------------------------



// google analytics -------------------------------------------------------------------------------
// define ID and host
// var hostname = '.' + 'fine-german-design.com';
// var googleAnalyticsID = 'UA-33695889-1';
// google analytics ----------------------------------

// run google analytics or disable
// ------------------------------------------------------------------------------------------------
function googleAnalytics() {
	
	 (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
	
				// for testing: //www.google-analytics.com/analytics_debug.js

            ga('create', googleAnalyticsID, 'auto');
            ga('set', 'anonymizeIp', true);
            ga('send', 'pageview');
				// log loaging og google analytics
            console.log("LOAD GA");
} 


// ------------------------------------------------------------------------------------------------



function clearAnalyticsCookie() {
		
	var gaProperty = googleAnalyticsID; 
    var disableStr = 'ga-disable-' + gaProperty; 
    if (document.cookie.indexOf(disableStr + '=true') > -1) { 
        window[disableStr] = true;
    } 
    function gaOptout() { 
        document.cookie = disableStr + '=true; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'; 
        window[disableStr] = true; 
        console.log('disable google analytics'); 
    }

}	


function clearPressAccessCookie() {
       //cookieconsent_status	deny	mf.senckenberg.de	/	29.5.2019, 16:18:04	24 B			
       // sgn-press-access	true	.mf.senckenberg.de	/	23.5.2019, 16:14:11	20 B			
        //document.cookie = 'sgn-press-access=false; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        document.cookie = 'sgn-press-access=false; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        //document.cookie = "sgn-press-access; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        console.log('disable sgn-press-access'); 
}	



// ------------------------------------------------------------------------------------------------

window.addEventListener("load", function(){
	
	var p;
	window.cookieconsent.initialise({
		  "palette": {
		    "popup": {
		      "background": "#e6e6e6",
		      "text": "#000000"
		    },
		    "button": {
		      "background": "#000000",
		      "text": "#ffffff"
		    }
		  },
		  "type": "opt-out",
		  "revokable": true,
		  
		  "content": {
		    "message": consentMessage,
		    "dismiss": consentDismiss,
		    "deny": consentDeny,
		    "link": consentLink,
		    "href": consentHref
		  },
		   
		  
		// -----------------------------------------------
		  
		  onInitialise: function (status) {
		  var type = this.options.type;
		  var didConsent = this.hasConsented();
		  if (type == 'opt-in' && didConsent) {
		    // enable cookies
		    console.log("Enable onInitialise");
			 
			 // run google anlytics
			 // googleAnalytics(); 
		  }
		  if (type == 'opt-out' && !didConsent) {
		    // disable cookies
		    console.log("Disable onInitialise");
		    	
		    // clear google analytics cookies
		    // clearAnalyticsCookie();
		   //  clearPressAccessCookie();
		    
		    
		  } else {
			 console.log("Enable onInitialise else");
			
			// run google anlytics
			// googleAnalytics();
			
			}
		},
		
		// -------------------------------------------------
		 
		onStatusChange: function(status, chosenBefore) {
		  var type = this.options.type;
		  var didConsent = this.hasConsented();
		  if (type == 'opt-in' && didConsent) {
		    // enable cookies
		     console.log("Cookie Consent: enable onStatusChange");
			 window.location.reload(true);
		    // run google anlytics
		    // googleAnalytics();
		    
		     }
		  if (type == 'opt-out' && !didConsent) {
		    // disable cookies
		     console.log("Cookie Consent: disable onStatusChange");
			 window.location.reload(true);
		    // clear google analytics cookies
		    // clearAnalyticsCookie();
		    // clearPressAccessCookie();
		    
		  } else {
			 console.log("Cookie Consent: enable onStatusChange else");
			 window.location.reload(true);
			// run google analytics
			// googleAnalytics();
			// _etracker.enableTracking();	
			
			}
		},
		
		// ------------------------------------------------
		 
		onRevokeChoice: function() {
		  var type = this.options.type;
		  if (type == 'opt-in') {
		    // disable cookies
		     console.log("Cookie Consent: disable onRevokeChoice");
			 window.location.reload(true);
		    // clear google analytics cookies
		    // clearAnalyticsCookie();
		    // clearPressAccessCookie();
		    
		  }
		  if (type == 'opt-out') {
		    // enable cookies
		     console.log("Cookie Consent: enable onRevokeChoice");
		    
		    // run google anlytics
			 // googleAnalytics();
			 window.location.reload(true);
		  } else {
			   console.log("Cookie Consent: disable onRevokeChoice else");
			   window.location.reload(true);
			 // clear google analytics cookies
		    // clearAnalyticsCookie();
		    // clearPressAccessCookie();	  
		  }
		},
		
		
	// ------------------------------------------------
   revokable: false,
   
    onRevokeChoice: function () {}
	 }, function (popup) {

    p = popup;
    var output = '';
    for (var property in p) {
      output += property + ': ' + p[property] + '; ';
    }
			// ------------------------------------------------	
	});
	
	
	// ------------------------------------------------
	//custom revoke button
	 if (document.getElementById('consent-revoke')) {
		 document.getElementById('consent-revoke').onclick = function (e) {
       // console.log("consent revokeChoice");
        p.revokeChoice();

      };
     } 
	  
	 if (document.getElementById('consent-revoke-soundcloud')) {
		 	document.getElementById('consent-revoke-soundcloud').onclick = function (e) {
		    // console.log("consent revokeChoice");
		     p.revokeChoice();
		  		
		   };
     }
	// ------------------------------------------------
});

  

